import React from "react";
import SideBar from "../components/Sidebar/SideBar";
import { Route, Routes } from "react-router-dom";
import Consulta from "../views/Consulta";

const User = () => {
  return (
    <div className="d-flex">
      <SideBar />
      <div className="content flex-grow-1">
        <Routes>
          <Route path="" element={<Consulta/>} />
        </Routes>
      </div>
    </div>
  );
};

export default User;
